import React from 'react';

const GraphicLayout = ({ children }) => {
  return <div className="graphics-layout">{children}</div>;
};

export default GraphicLayout;
